export default __webpack_public_path__ + "static/me-e1ede01d808b18c99264c33d15a86812.webp";